import React from 'react';
import PropTypes from 'prop-types';

import timeUtils from '../../../../qti/utils/TimeUtils';
import CancelButton from './CancelButton';

import styles from './uploadInteraction.scss';

class UploadViewFileUploading extends React.Component {
    static propTypes = {
        cancelUpload: PropTypes.func.isRequired,
        selectedFile: PropTypes.object.isRequired,
        services: PropTypes.object.isRequired,
        uploadProgress: PropTypes.number.isRequired,
        uploadProgressEstimatedMsRemaining: PropTypes.number,
    };

    componentDidMount() {
        this.initiallyFocusedElement.focus();
    }

    /**
     * Gets the text for the estimated time left message, based on the number of milliseconds left before completion.
     * @param {int} ms Estimated number of milliseconds remaining.
     */
    getTimeLeftString = (ms) => {
        const { t } = this.props.services.translationService;
        const formattedDuration = timeUtils.formatDuration(ms, t);

        return t('interactions.upload.estimatedTimeLeft', { formattedDuration });
    };

    render() {
        const { uploadProgress, uploadProgressEstimatedMsRemaining, selectedFile, services } = this.props;
        const { t } = services.translationService;
        const formattedDuration = timeUtils.formatDuration(uploadProgressEstimatedMsRemaining, t);
        const progressPercentage = Math.ceil(uploadProgress * 100);
        return (
            <div className={styles.fileUploadingView}>
                <div>
                    <span
                        ref={(span) => { this.initiallyFocusedElement = span; }}
                        tabIndex="-1"
                        className={styles.fileUploadingWrapper}
                        dangerouslySetInnerHTML={{
                            __html: t('interactions.upload.uploadingFileName', { fileName: selectedFile.name }),
                        }}
                    />
                    <div className={styles.progressBarRow}>
                        <progress max="100" value={progressPercentage} ref={(progressBar) => { this.progressBar = progressBar; }}>
                            <div className={styles.progressBarWrapper}>
                                <div className={styles.progressBar} style={{ width: `${progressPercentage}%` }}>&nbsp;</div>
                            </div>
                        </progress>
                        <CancelButton
                            services={services}
                            cancelUpload={this.props.cancelUpload}
                        />
                    </div>
                    <div className={styles.progressInfoRow}>
                        <div>{progressPercentage}%</div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: t('interactions.upload.estimatedTimeLeft', { formattedDuration }),
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default UploadViewFileUploading;
